import { Flex, Tooltip } from '@radix-ui/themes'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { RxStarFilled, RxStar } from 'react-icons/rx'

import { Icon } from '#app/components/ui/icon.tsx'
import { type productReviewRating } from '#app/models/ecommerce-providers/sylius/shop/interface/product-review.ts'

/* -------------------------------------------------------------------------------------------------
 * I18next
 * -----------------------------------------------------------------------------------------------*/

enum I18NEXT {
	uiRating = 'ui-rating',
}

/* -------------------------------------------------------------------------------------------------
 * Rating
 * -----------------------------------------------------------------------------------------------*/

type RatingElement = React.ElementRef<'ul'>
type RatingProps = {
	children: productReviewRating
}

const Rating = React.forwardRef<RatingElement, RatingProps>(
	(props, forwardRef) => {
		const { children } = props
		const { t } = useTranslation(I18NEXT.uiRating)

		return (
			<Flex className="app-Rating" display="inline-flex">
				<Tooltip content={t('common.productRated-$val-Of5', { val: children })}>
					<Flex asChild align="center" gapX="1">
						<ul ref={forwardRef}>
							{[...Array(5).keys()].map((x) => (
								<li key={x}>
									<Icon size="2" className="text-yellow-8">
										{x < children ? (
											<RxStarFilled size="1em" />
										) : (
											<RxStar size="1em" />
										)}
									</Icon>
								</li>
							))}
						</ul>
					</Flex>
				</Tooltip>
			</Flex>
		)
	},
)
Rating.displayName = 'Rating'

/* -----------------------------------------------------------------------------------------------*/

export { type RatingProps, Rating, I18NEXT as RATING_I18NEXT }
